import {assetIsPresent} from '@netx/core-asset/utils';
import {
	allows,
	PermissionMatrixName,
} from '@netx/core-permissions/utils/allows';
import {currentUserMeetsUserLevel} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {ASSET_RESYNC_MINIMUM_USER_LEVEL} from '../constants';
import {type IAsset} from '../schema';

export const canResyncAsset = (asset?: IAsset) =>
	asset != null &&
	currentUserMeetsUserLevel(ASSET_RESYNC_MINIMUM_USER_LEVEL) &&
	assetIsPresent(asset) &&
	allows(asset.permissionMatrix, PermissionMatrixName.MODIFY);

export default canResyncAsset;
